import { render, staticRenderFns } from "./RegisterGoodbye.vue?vue&type=template&id=2efe12a3&scoped=true"
import script from "./RegisterGoodbye.vue?vue&type=script&lang=js"
export * from "./RegisterGoodbye.vue?vue&type=script&lang=js"
import style0 from "./RegisterGoodbye.vue?vue&type=style&index=0&id=2efe12a3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2efe12a3",
  null
  
)

export default component.exports